import { SidebarGroup, SidebarGroupContent } from '../ui/Sidebar';

interface SidebarCalloutProps {
  /** Show WhatsApp community callout (default: true, only for creators) */
  showWhatsApp?: boolean;
}

export function SidebarCallout({ showWhatsApp = true }: SidebarCalloutProps) {
  // If WhatsApp is disabled, don't render anything
  if (!showWhatsApp) {
    return null;
  }

  return (
    <SidebarGroup>
      <SidebarGroupContent>
        {/* WhatsApp Community Callout */}
        <div className="rounded-lg border border-green-100 bg-gradient-to-br from-green-50 to-white p-3 text-sm">
          <div className="flex items-start gap-2">
            {/* Inline WhatsApp icon */}
            <svg
              viewBox="0 0 24 24"
              className="h-4 w-4 text-green-600 mt-0.5 flex-shrink-0"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M20.52 3.48A11.94 11.94 0 0 0 12.06 0C5.46 0 .1 5.36.1 11.96c0 2.11.55 4.17 1.6 6L0 24l6.21-1.63a12 12 0 0 0 5.84 1.52h.01c6.6 0 11.96-5.36 11.96-11.96A11.9 11.9 0 0 0 20.52 3.48Zm-8.46 18.32c-1.94 0-3.85-.52-5.52-1.5l-.4-.24-3.69.97.99-3.6-.26-.37A9.93 9.93 0 0 1 2.02 12C2.02 6.9 6.2 2.72 11.3 2.72c2.65 0 5.14 1.03 7.02 2.9a9.86 9.86 0 0 1 2.94 7.02c0 5.1-4.18 9.28-9.2 9.28Zm5.33-6.93c-.29-.15-1.7-.83-1.97-.92-.27-.1-.47-.15-.67.15-.2.29-.77.92-.95 1.11-.18.2-.35.22-.64.08-.29-.15-1.22-.45-2.32-1.45-.86-.77-1.44-1.72-1.61-2.01-.17-.29-.02-.45.13-.6.13-.13.29-.35.44-.53.15-.18.2-.3.29-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.5-.17-.01-.37-.01-.57-.01-.2 0-.52.07-.79.37-.27.29-1.04 1.02-1.04 2.49 0 1.47 1.07 2.89 1.22 3.09.15.2 2.1 3.2 5.11 4.49.71.31 1.27.49 1.71.63.72.23 1.38.2 1.9.12.58-.09 1.7-.69 1.94-1.36.24-.67.24-1.25.17-1.36-.07-.11-.26-.18-.55-.33Z" />
            </svg>
            <div className="space-y-1">
              <p className="font-medium text-foreground font-satoshi">
                WhatsApp community
              </p>
              <a
                href="https://chat.whatsapp.com/Gt2aapBUgh8BeLZxZSyxgF"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-xs font-medium text-green-600 hover:text-green-700 transition-colors hover:underline"
              >
                Join now
              </a>
            </div>
          </div>
        </div>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
